import { CSSProperties } from "@mui/material/styles";

export function LexIcon({
  clipPath,
  style,
  color,
}: {
  clipPath?: string;
  style?: CSSProperties;
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 180 80"
      width="180"
      height="80"
      clipPath={clipPath}
      style={style}
      overflow="visible"
    >
      <text
        x="0"
        y="60"
        fontSize="64"
        fontWeight="800"
        fontFamily="Arial, Helvetica, sans-serif"
        fill={color || "#b50000"}
      >
        L
      </text>

      <text
        x="55"
        y="60"
        fontSize="64"
        fontWeight="800"
        fontFamily="Arial, Helvetica, sans-serif"
        fill={color || "#bf9e5c"}
      >
        E
      </text>

      <text
        x="110"
        y="60"
        fontSize="64"
        fontWeight="800"
        fontFamily="Arial, Helvetica, sans-serif"
        fill={color || "#b50000"}
      >
        X
      </text>
    </svg>
  );
}
